export const galateaNotificationTypeLiteral = ['print-book', 'other'] as const;
export const galateaNotificationPriorityLiteral = ['normal', 'high', 'urgent'] as const;
